<template>
    <transition name="overlay">
        <section class="designForm modal" v-if="$store.state.designFormStatus">
            <button class="modal__close" title="close" type="button" @click="closeModal">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#close"/>
                </svg>
            </button>
            <div class="container">
                <h2 class="title" v-if="!success">Заказ дизайн проекта</h2>
                <p class="h3 form__success" v-if="success">
                    <img class="form__success-img" src="/assets/img/other/snail.png" alt="">
                    <span class="form__success-text">
                        Заявка успешно отправлена! Мы свяжемся с Вами в ближайшее время.
                    </span>
                </p>
                <form class="form" v-if="!success" @submit.prevent="formSubmit">
                    <input-text v-model="designForm.name"
                                :v="$v.designForm.name"
                                placeholder="Ваше имя"
                                errorText="Укажите имя"/>
                    <input-phone v-model="designForm.phone"
                                 :v="$v.designForm.phone"
                                 errorText="Укажите корректный номер"
                                 placeholder="Телефон"/>
                    <div class="input">
                        <v-select :options="cities"
                                  :multiple="false"
                                  :searchable="false"
                                  v-model="designForm.city"
                                  @change="$v.designForm.city.$touch()"
                                  @blur="$v.designForm.city.$touch()"
                                  required
                                  placeholder="Укажите область">
                        </v-select>
                        <span class="input__error" v-if="$v.designForm.city.$error">Укажите область</span>
                    </div>
                    <customTextarea v-model="designForm.comment"
                                 :v="$v.designForm.comment"
                                 placeholder="Опишите задачу"/>
                    <input-file v-model="designForm.file"
                                fileInputName="designFormFile"
                                 :v="$v.designForm.file"/>
                    <custom-checkbox
                        :v="$v.designForm.politics"
                        v-model="designForm.politics"
                        :class="{_error: $v.designForm.politics.$error}"
                        checkboxName="politicsDesignForm"
                        checkboxText="Отправляя форму, Вы даёте согласие на обработку персональных данных"/>
                    <button class="btn" type="submit">Отправить</button>
                </form>
            </div>
        </section>
    </transition>
</template>

<script>
import inputPhone from "../common/inputPhone";
import inputText from "../common/inputText";
import inputFile from "../common/inputFile";
import customCheckbox from "../common/custom-checkbox";
import customTextarea from "../common/customTextarea";
import {required, minLength, maxLength, sameAs} from "vuelidate/lib/validators";

export default {
    name: 'designForm',
    components: {inputText, inputPhone, inputFile, Inputmask, customCheckbox, customTextarea},
    props: {
        visibleStatus: false
    },
    data() {
        return {
            designForm: {
                phone: null,
                name: null,
                city: null,
                file: null,
                recaptcha: null,
                url: null,
                comment: null,
                type: 'design',
                politics: true
            },
            cities: this.$store.state.cities,
            success: false,
        }
    },
    validations: {
        designForm: {
            name: {
                required,
                minLength: minLength(2)
            },
            city: {required},
            comment: {},
            file: {},
            politics: {
                sameAs: sameAs( () => true )
            },
            phone: {
                required,
                minLength: minLength(18),
                maxLength: maxLength(18),
                correctAddress(phone) {
                    return /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(phone)
                }
            }
        }
    },
    methods: {
        formSubmit() {
            this.$v.designForm.$touch();
            if (this.$v.designForm.$pending || this.$v.designForm.$error) {

            } else {
                this.recaptcha().then(token => {
                    this.designForm.recaptcha = token;
                    this.designForm.url = window.location.href;
                    this.$http.post('/api/forms/callback', this.makeFormData(this.designForm)).then(res => {

                    })
                    this.success = true;
                    ym(1980352,'reachGoal','designOrder')
                });
            }
        },

        closeModal() {
            this.visibleStatus = false;
            this.$store.commit('setModalStatus', false);
            this.$store.commit('setOverlayStatus', false);
            this.$store.commit('setDesignFormStatus', false);
            document.body.classList.remove('_no-scroll');
        },
    },
}
</script>
